import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { StoreModule } from '@ngrx/store';

import { ManagementTokensReducer } from './management.reducer';
import { ManagementTokensEffects } from './management.effects';
import { EffectsModule } from '@ngrx/effects';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature('management', ManagementTokensReducer),
    EffectsModule.forFeature([ManagementTokensEffects]),
  ],
  providers: [],
})
export class ManagementTokensStoreModule {}
